import React, { Component } from 'react';
import PropTypes from 'prop-types';
import createIcon from 'utils/createIcon';
import GroupIcon from 'common/icons/Group';

import { SuiContainer } from '@splashthat/sui';
import Alphatar from 'common/components/Alphatar';

import './styles.styl';

const BASE_CLASS_NAME = 'ContactRow';

export default class ContactRow extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        subheadline: PropTypes.string,
        isGroup: PropTypes.bool,
        imageUrl: PropTypes.string,
        action: PropTypes.node,
    };

    static defaultProps = {
        subheadline: null,
        isGroup: false,
        imageUrl: null,
        id: null,
        action: null,
    };

    render() {
        const { name, subheadline, action, isGroup, imageUrl } = this.props;

        return (
            <SuiContainer className={BASE_CLASS_NAME}>
                <SuiContainer className={`${BASE_CLASS_NAME}__content-wrapper`} variation="flex-horizontal">
                    <SuiContainer className={`${BASE_CLASS_NAME}__avatar-wrapper`} variation="flex-group">
                        <Alphatar icon={isGroup ? createIcon(GroupIcon) : null} imageUrl={imageUrl} name={name} />
                    </SuiContainer>
                    <SuiContainer className={`${BASE_CLASS_NAME}__data-wrapper`} variation="flex-group flex-vertical">
                        <h5 className={`${BASE_CLASS_NAME}__name`}>{name}</h5>
                        {subheadline && <h6 className={`${BASE_CLASS_NAME}__subheadline`}>{subheadline}</h6>}
                    </SuiContainer>
                    {action && <SuiContainer className={`${BASE_CLASS_NAME}__action-wrapper`}>{action}</SuiContainer>}
                </SuiContainer>
            </SuiContainer>
        );
    }
}
